import React, { FC, ReactNode } from 'react';

interface DetailsRightProps {
  title: string;
  detailsList: { title: string; value: string | number | ReactNode }[][];
}

const DetailsRight: FC<DetailsRightProps> = ({ title, detailsList }) => (
  <div className="details__col">
    <h2 className="text-2 details__title">{title}</h2>
    <div className="details__list__container">
      {detailsList.map((detail) => (
        <div className="details__list__col">
          {detail.map(
            (
              d: { title: string; value: string | number | ReactNode },
              index: number
            ) => (
              <div
                className="details__list__item"
                key={`details__list__item-${index}`}
              >
                <div className="details__list__item__title">{d.title}</div>
                <div className="details__list__item__text">{d.value}</div>
              </div>
            )
          )}
        </div>
      ))}
    </div>
  </div>
);

export default DetailsRight;
